import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@efexteam/components';
import Typography from '@mui/material/Typography';
import { moneyIcon } from '@pages/lending/assets';
import { ActionModalProps } from '@pages/lending/types';
import ACTIONS from '@pages/lending/types/actionsEnum.type';
import { useTranslation } from 'react-i18next';
import Details from '../../Details/Details';

const ActionModal = ({
  open,
  actionType,
  onAccept,
  onReject,
  onCancel,
}: ActionModalProps) => {
  const { t } = useTranslation();
  const isAccept = actionType === ACTIONS.ACCEPT;
  return (
    <Dialog open={open} className="w-full" maxWidth="sm" onClick={onCancel}>
      <DialogTitle className="text-center" showCloseButton onClick={onCancel}>
        {t(isAccept ? 'ldExpAcceptTitle' : 'ldExpRejectTitle')}
      </DialogTitle>
      <DialogContent>
        <img
          src={moneyIcon}
          className="w-24 h-24 m-auto mb-3"
          alt="accept credit"
        />
        <Typography gutterBottom>
          {t(isAccept ? 'ldExpAcceptDescription' : 'ldExpRejectDescription')}
        </Typography>
        <Details detailType={actionType} />
      </DialogContent>
      <DialogActions className="!justify-around">
        <Button
          appearance="secondary"
          color="info"
          autoFocus
          onClick={onCancel}
        >
          {t('ldExpCancelBtn')}
        </Button>
        {isAccept ? (
          <Button appearance="primary" autoFocus onClick={onAccept}>
            {t('ldExpAcceptBtn')}
          </Button>
        ) : (
          <Button
            appearance="primary"
            color="error"
            autoFocus
            onClick={onReject}
          >
            {t('ldExpRejectBtn')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ActionModal;
